import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-4 font-medium text-sm text-green-600"
};
const _hoisted_2 = { class: "form-floating mb-3" };
const _hoisted_3 = { class: "form-floating mb-3" };
const _hoisted_4 = { class: "form-check mb-3" };
const _hoisted_5 = ["checked"];
const _hoisted_6 = ["disabled"];
import { responseMessages } from '@/Composables/responseMessages';
import { useForm } from '@inertiajs/vue3';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginForm',
    props: {
        canResetPassword: Boolean,
        status: {
            type: String,
            default: null,
        },
    },
    emits: ['loggedIn'],
    setup(__props, { emit: __emit }) {
        let { showErrorSwal } = responseMessages();
        const props = __props;
        const emit = __emit;
        const form = useForm({
            email: '',
            password: '',
            remember: false
        });
        function submit() {
            form.post(route('login'), {
                onFinish: () => {
                    form.reset('password');
                    emit('loggedIn');
                },
                onError: (errors) => {
                    showErrorSwal('Zugangsdaten fehlerhaft');
                },
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                onSubmit: _withModifiers(submit, ["prevent"])
            }, [
                (props.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.status), 1))
                    : _createCommentVNode("", true),
                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-center fw-light mb-4" }, "Anmeldung", -1)),
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: "form-control",
                        id: "email",
                        placeholder: "E-Mail/Benutzername",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).email) = $event))
                    }, null, 512), [
                        [_vModelText, _unref(form).email]
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("label", { for: "email" }, "Benutzername", -1))
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                        type: "password",
                        class: "form-control",
                        id: "password",
                        placeholder: "Password",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).password) = $event))
                    }, null, 512), [
                        [_vModelText, _unref(form).password]
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("label", { for: "password" }, "Passwort", -1))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "remember",
                        checked: _unref(form).remember
                    }, null, 8, _hoisted_5),
                    _cache[4] || (_cache[4] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "remember"
                    }, " Angemeldet bleiben? ", -1))
                ]),
                _createElementVNode("button", {
                    class: "w-100 btn btn-primary d-flex align-items-center justify-content-center text-white",
                    disabled: _unref(form).processing
                }, [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Login", -1),
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                            class: "ms-2 bi bi-arrow-right",
                            viewBox: "0 0 16 16"
                        }, [
                            _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            })
                        ], -1)
                    ]))], 8, _hoisted_6)
            ], 32));
        };
    }
});
